export default {"src":"/_next/static/media/ripples.6ad73c03.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};